<template>
    
    <div class="cosafacciamocontainer">
        <div>{{ slogan }}</div>
        <div v-if="currentlang=='it'">
              <div class="itemcosafacciamo">
                <cmpcollapsible title="Lighting" slogan="Accendiamo cose" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>In oltre dieci anni di esperienza<br/>
                      nel settore del Lighting<br/>
                      abbiamo acceso un sacco di cose.
                    </p>
                    <p>Scopri la nostra esperienza luminosa su<br/>
                      <i><b><a target="_blank" :href="linknewlablight">www.newlablight.com</a></b></i>
                    </p>
                    <p>oppure dai un’occhiata ai nostri case studies</p>
                    
                    <br/>
                    <a :href="linkcaselighting"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                    
                </cmpcollapsible>
                <cmpcollapsible title="Gaming" slogan="Giochiamo con i circuiti" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>Il team di progettazione interno della Newlab negli ultimi 10 anni si è occupato di progettare e ingegnerizzare diversi prodotti elettronici dedicati al gaming.</p>
                    <p>Robot, giochi elettronici consumer, e quant'altro è necessario a far divertire i nostri figli e amici.</p>
                    <p>Il frutto di queste competenze è la capacità di targettizzare il progetto elettronico in rapporto a grossi volumi di produzione con target prezzo estremamente ridotto.</p>
                    <p>Dai un’occhiata ai nostri case studies</p>
                    <br/>
                    <a :href="linkcasegaming"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Nautical" slogan="Issiamo le vele" @sigcollapse="fnOnSigCollapse">
                    <br/>
                      <p>Siamo partner tecnologici di diverse aziende del settore nautico che utilizzano le nostre competenze di sviluppo elettronico e software per innovare i propri prodotti.</p>
                      <p>Recuperatori di bordo, sistemi di gestione domotici e sensori fanno parte del nostro know-how.</p>
                      <p>La ricerca nel settore Nautico è strettamente legata alla capacità di Newlab di applicare, in questo settore, le tecnologie di ultima generazione sviluppate in altri mercati.</p>
                    <p>Dai un’occhiata ai nostri case studies</p>
                    <br/>
                    <a :href="linkcasenautical"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Wearable" slogan="Indossiamo tecnologia" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>Frutto di esperienze nella progettazione, industrializzazione e produzione di localizzatori GSM e trasmissione dati wireless nei primi anni 2000, il team di Newlab, negli ultimi sei anni ha trovato nuovi sbocchi commerciali realizzando diversi prodotti Wearable.</p>
                    <p>Bracciali localizzatori su tecnologia NB-IOT/CAT-M, occhiali tecnologici e sensoristica wearable sono alcuni dei nostri prodotti custom sviluppati.</p>
                    <p>Dai un’occhiata ai nostri case studies</p>
                    <br/>
                    <a :href="linkcasewearable"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="IoT" slogan="Connettiamo dispositivi" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>Dal 2015 abbiamo ampliato le nostre competenze investendo e portando al nostro interno la capacità di sviluppare software. </p>
                    <p>Questo grande passo in avanti ci ha permesso di realizzare il nostro primo sistema completo di gestione e recupero dei dati da dispositivi IoT. </p>
                    <p>Il frutto di questo lavoro è <i><b><a target="_blank" :href="linkomni">OMNI</a></b></i>, il primo sistema Hardware, Firmware e Software completamente customizzabile per la gestione dei dispositivi remoti.</p>
                    <p>Il sistema <i><b><a target="_blank" :href="linkomni">OMNI</a></b></i>, biglietto da visita delle competenze di sistema Newlab è stato approvato e certificato con le interazioni a sistemi complessi come <i><b><a target="_blank" :href="linkskillgoogle">Google Nest</a></b></i>, <i><b><a target="_blank" :href="linkskillalexa">Amazon Alexa</a></b></i> e <i><b><a target="_blank" :href="linkskillifttt">IFTTT</a></b></i>.</p>
                    <p>Dai un’occhiata ai nostri case studies</p>
                    <br/>
                    <a :href="linkcaseiot"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Voice Assistant" slogan="Parliamo con gli oggetti" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>Con l'avvento degli assistenti vocali, Newlab è stata la prima azienda italiana a pubblicare le Skill per i propri prodotti Lighting con approvazione terza da parte di <i><b><a target="_blank" :href="linkskillgoogle">Google</a></b></i> e <i><b><a target="_blank" :href="linkskillalexa">Amazon</a></b></i>.</p>
                    <p>La gestione interna di tali processi di sviluppo permette a Newlab di realizzare Skill custom legate ai settori più disparati.</p>
                    <p>Lighting, elettrodomestico, attuazioni e l'intera gestione dei profili Amazon e Google permettono alla nostra azienda di supportare il cliente nell'integrazione di queste tecnologie innovative nei propri prodotti avendo una sola interfaccia per la gestione Hardware, Firmware e Software.</p>
                    <p>Dai un’occhiata ai nostri case studies</p>
                    <br/>
                    <a :href="linkcasevoiceassistant"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Miscellanea" slogan="... e tanto altro" @sigcollapse="fnOnSigCollapse">
                     <br/>
                     <p>Con 20 anni di esperienza nella fornitura di progettazione e produzione di prodotti elettronici, Newlab è riuscita a risolvere concretamente diverse problematiche dei clienti nei settori più disparati. </p>
                     <p>Applicazioni militari, medicali, segnalazione stradale e ferroviario sono alcuni settori su cui abbiamo applicato le nostre competenze tecniche per aiutare i nostri clienti a risolvere problemi tecnici.</p>
                      <p>Dai un’occhiata ai nostri case studies</p>
                    <br/>
                    <a :href="linkcasemiscellanea"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
              </div>
        </div>


        <div v-if="currentlang=='en'">
              <div class="itemcosafacciamo">
                <cmpcollapsible title="Lighting" slogan="We turn on things" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>In over ten years of experience<br/>
                       in the lighting sector<br/>
                       we turned on a lot of things.
                    </p>
                    <p>Discover our light experience on<br/>
                      <i><b><a target="_blank" :href="linknewlablight">www.newlablight.com</a></b></i>
                    </p>
                    <p>or take a look at our case studies</p>
                    
                    <br/>
                    <a :href="linkcaselighting"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                    
                </cmpcollapsible>
                <cmpcollapsible title="Gaming" slogan="We play with circuits" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>Over the past 10 years, the internal design team of Newlab has been involved in designing and engineering various electronic products dedicated to gaming.</p>
                    <p>Robots, consumer electronic games, and whatever else is needed to entertain our children and friends.</p>
                    <p>The result of these skills is the ability to target the electronic project in relation to large production volumes with an extremely reduced price target.</p>
                    <p>Take a look at our case studies</p>
                    <br/>
                    <a :href="linkcasegaming"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Nautical" slogan="We hoist the sails" @sigcollapse="fnOnSigCollapse">
                    <br/>
                      <p>We are technological partners of several companies in the marine sector that use our electronic and software development skills to innovate their products.</p>
                      <p>On-board recuperators, home automation management systems and sensors are part of our know-how.</p>
                      <p>Research in the Nautical sector is closely linked to Newlab’s ability to apply, in this sector, the latest generation technologies developed in other markets.</p>
                    <p>Take a look at our case studies</p>
                    <br/>
                    <a :href="linkcasenautical"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Wearable" slogan="We wear technology" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>The result of experience in the design, industrialization and production of GSM trackers and wireless data transmission in the early 2000s, the Newlab team, in the last six years, has found new commercial outlets by making various Wearable products.</p>
                    <p>Tracking bracelets on NB-IOT / CAT-M technology, technological glasses and wearable sensors are some of our custom developed products.</p>
                    <p>Take a look at our case studies</p>
                    <br/>
                    <a :href="linkcasewearable"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="IoT" slogan="We connect devices" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>Since 2015 we have expanded our skills by investing and bringing within ourselves the ability to develop software.</p>
                    <p>This great step forward has allowed us to create our first complete system for managing and recovering data from IoT devices.</p>
                    <p>The result of this work is <i><b><a target="_blank" :href="linkomni">OMNI</a></b></i>, the first completely customizable Hardware, Firmware and Software system for the management of remote devices.</p>
                    <p>The <i><b><a target="_blank" :href="linkomni">OMNI</a></b></i> system, business card of system skills Newlab has been approved and certified with interactions to complex systems such as <i><b><a target="_blank" :href="linkskillgoogle">Google Nest</a></b></i>, <i><b><a target="_blank" :href="linkskillalexa">Amazon Alexa</a></b></i> and <i><b><a target="_blank" :href="linkskillifttt">IFTTT</a></b></i>.</p>
                    <p>Take a look at our case studies</p>
                    <br/>
                    <a :href="linkcaseiot"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Voice Assistant" slogan="We talk with things" @sigcollapse="fnOnSigCollapse">
                    <br/>
                    <p>With the advent of voice assistants, Newlab was the first Italian company to publish the Skills for its Lighting products with third party approval of <i><b><a target="_blank" :href="linkskillgoogle">Google</a></b></i> and <i><b><a target="_blank" :href="linkskillalexa">Amazon</a></b></i>.</p>
                    <p>The internal management of these development processes allows Newlab to create custom skills linked to the most diverse sectors.</p>
                    <p>Lighting, household appliances, implementations and the entire management of Amazon and Google profiles allow our company to support the customer in the integration of these innovative technologies in its products by having a single interface for Hardware, Firmware and Software management.</p>
                    <p>Take a look at our case studies</p>
                    <br/>
                    <a :href="linkcasevoiceassistant"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
                <cmpcollapsible title="Miscellaneous" slogan="... and much more" @sigcollapse="fnOnSigCollapse">
                     <br/>
                     <p>With 20 years of experience in the supply of design and production of electronic products, Newlab has been able to concretely solve various customer problems in the most disparate sectors.</p>
                     <p>Military, medical, road and rail signaling applications are some sectors on which we have applied our technical skills to help our customers solve technical problems.</p>
                    <p>Take a look at our case studies</p>
                    <br/>
                    <a :href="linkcasemiscellanea"> 
                        <img src="@/assets/images/arrow_left.svg" /><br/><b>case studies</b>
                    </a>
                    <br v-for="index in 4" :key="index" />
                </cmpcollapsible>
              </div>
        </div>

    </div>

 
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

import cmpcollapsible from "../components/cmpcollapsible.vue"

export default {
  name: "cmpcosafacciamo",
  mixins:[multilangmixin],
  emits:["sigpageresized"],
  
  components:{
    cmpcollapsible
  },

  data(){
      return {
                "linknewlablight":"https://www.newlablight.com",
                "linkomni":"https://www.newlablight.com/omni-cose/",
                "linkskillgoogle":"https://assistant.google.com/services/a/uid/00000093b3eeec97?source=web",
                "linkskillalexa":"https://www.amazon.it/Newlab-S-r-l/dp/B07GXQ19QR",
                "linkskillifttt":"https://ifttt.com/omninewlab",
            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },

  computed:{

      slogan(){
          return this.fnGetTranslation(this.currentlang,"lavoriamo");
      },
       
      linkcaselighting(){
          return "/"+this.currentlang+ "/casestudies?category=lighting";
      },

      linkcasegaming(){
          return "/"+this.currentlang+ "/casestudies?category=gaming";
      },

      linkcasenautical(){
          return "/"+this.currentlang+ "/casestudies?category=nautical";
      },

      linkcasewearable(){
          return "/"+this.currentlang+ "/casestudies?category=wearable";
      },


      linkcaseiot(){
          return "/"+this.currentlang+ "/casestudies?category=iot";
      },

      linkcasevoiceassistant(){
          return "/"+this.currentlang+ "/casestudies?category=voiceassistant";
      },

      linkcasemiscellanea(){
          return "/"+this.currentlang+ "/casestudies?category=miscellaneous";
      }




  },


  methods:{


      fnOnSigCollapse()
      {
          this.$emit("sigpageresized");
      }

  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    


  .cosafacciamocontainer {
    display: flex;
    
    justify-content: center;
    flex-wrap: wrap;

    min-height: 70vh;

  }

  .cosafacciamocontainer > div {
    
    margin: 10px;
    padding: 20px;

    font-weight: 800;
    font-size: 2em;

    max-width: 450px;
    flex-grow: 4;
        
    
  }


  @media screen and (min-width: 600px)    {
      /*  schermo desktop */
    
 

      .headlineslogan
      {
        margin-left: 0px;
        max-width: 450px;
        min-height: 200px;
        font-weight: 800;
        font-size: 2em;
        padding-top: 30px;
        padding-left: 80px;
        border-width: 0px;
                
      }
    

  }
  
  @media screen and (max-width: 600px) {
     /*  schermo mobile */
  
    .headlineslogan
    {
      margin-left: 0px;
      margin-right: 0px;
      padding-top: 30px;
      padding-left: 20px;
      padding-right: 20px;
      
      min-height: 200px;
      font-weight: 800;
      font-size: 1.4em;


    }
  
 
  }


</style>
